export const OVERVIEW_ROUTE = {
    title: 'Overview',
    name: 'affiliate-overview',
};
export const OVERVIEW_PRODUCTS_ROUTE = {
    title: `Today's Latest Sold Products`,
    name: 'affiliate-sold-products',
};
